import Styles from 'components/Wizards/SelectImages/GeneratedImage.module.scss'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import AlertTriangle from 'blaze-ui/icons/20/AlertTriangle'
import { Button } from 'blaze-ui/Button'
import { ErrorImageProps } from 'components/Wizards/SelectImages/Types'
import cx from 'classnames'

export const ErrorImage = ({ onTryAgain }: ErrorImageProps) => (
  <div className={cx(Styles.image, Styles.error)}>
    <div className={Styles.content}>
      <AlertTriangle size={24} />
      <span>Failed to generate</span>
    </div>
    <Button variant="secondary" size="xs" frontIcon={ArrowRefresh2} onPress={onTryAgain}>
      Try Again
    </Button>
  </div>
)
